import { ChangeDetectionStrategy, Component, inject, output, input } from '@angular/core';
import { Router } from '@angular/router';
import { MatToolbar } from '@angular/material/toolbar';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatToolbar,
    MatButton,
    MatIconButton,
    MatIcon
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class HeaderComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  public readonly menuToggled = output<void>();
  public readonly hideToggle = input<boolean>(false);

  onToggleMenu() {
    this.menuToggled.emit();
  }

  async onSignOut() {
    try {
      await this.authService.signOut();
      this.router.navigate(['/sign-in']);
    } catch (error) {
      console.error('Sign out error:', error);
    }
  }
}
